import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import PropTypes from "prop-types";

const FileViewerDialog = ({ fileUrl, fileType, onClose, t }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={!!fileUrl}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      aria-labelledby="file-viewer-dialog-title"
      sx={{
        "& .MuiDialog-paper": {
          boxShadow: theme.shadows[20],
        },
      }}
    >
      <DialogTitle
        id="file-viewer-dialog-title"
        sx={{
          bgcolor: "primary.main",
          color: "primary.contrastText",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" component="span" fontWeight="bold">
          {t("documentDetail.attachmentPreviewTitle")}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "inherit" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ height: "80vh", p: 0 }}>
        {fileType === "pdf" && (
          <embed
            src={fileUrl}
            type="application/pdf"
            width="100%"
            height="100%"
            title={t("documentDetail.pdfPreviewTitle")}
            aria-label={t("documentDetail.pdfPreviewAria")}
          />
        )}
        {fileType === "office" && (
          <iframe
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            title={t("documentDetail.officePreviewTitle")}
          />
        )}
        {fileType === "image" && (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 2,
              bgcolor: "background.paper",
            }}
          >
            <img
              src={fileUrl}
              alt={t("documentDetail.attachmentAlt")}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                borderRadius: theme.shape.borderRadius,
                boxShadow: theme.shadows[4],
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, bgcolor: "background.paper" }}>
        <Button onClick={onClose} color="primary" variant="outlined">
          {t("documentDetail.closeButton")}
        </Button>
        {fileType === "pdf" && (
          <Button
            href={fileUrl}
            download
            color="primary"
            variant="contained"
            startIcon={<DownloadIcon />}
          >
            {t("documentDetail.downloadPdfButton")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

FileViewerDialog.propTypes = {
  fileUrl: PropTypes.string,
  fileType: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default FileViewerDialog;
